module.exports = __webpack_public_path__ + "8a4192fc7478e4833f68eee4eb5eb3af.png";